import { useTranslation } from 'react-i18next';
import FormFields from '../../../../../../../themes/admin/Fields/FormFields';
import useSystemSwitchData from '../../../../../../../utilities/useSystemSwitchData';
import ColumnOrFragment from './ColumnOrFragment';
import { type MarketInputsProps } from './NewZealandMarketInput';

const SingaporeMarketInput = ({ name, asFragment, dealers }: MarketInputsProps) => {
    const { t } = useTranslation('moduleDetails');
    const { yesNoSwitch } = useSystemSwitchData();

    return (
        <ColumnOrFragment asFragment={asFragment} md={8} xs={24}>
            <FormFields.SwitchField
                {...t('moduleDetails:fields.coe.coeEditable', { returnObjects: true })}
                {...yesNoSwitch}
                name={`${name}.coe.editable`}
            />
        </ColumnOrFragment>
    );
};

export default SingaporeMarketInput;
